;(function() {
  'use strict'

  edgeService.$inject = ["$q", "userService", "edgesResource"];
  angular.module('core.services').factory('edgeService', edgeService)

  // --------------------

  /* @ngInject */
  function edgeService($q, userService, edgesResource) {
    return {
      create: create,
      remove: remove,
    }

    // --------------------

    function create(edgeName, type, id) {
      return $q(function(resolve, reject) {
        if (!id) {
          return reject()
        }

        edgesResource
          .create({
            nodes: [
              {
                type: 'user',
                id: userService.get().id,
              },
              {
                type: type,
                id: id,
              },
            ],
            edge: {
              type: edgeName,
            },
          })
          .success(function(resp) {
            resolve(resp.id)
          })
          .error(reject)
      })
    }

    function remove(id) {
      return $q(function(resolve, reject) {
        edgesResource
          .remove({ id: id })
          .success(resolve)
          .error(reject)
      })
    }
  }
})()
